import { addRtkQueryBridges, buildSlice, CommonState, Row } from '~libs/reduxUtils';

import { typePrefix, usersRunningLateApi } from '~weekly-planner/actions/users/runningLate';

interface State extends CommonState<Row> {
  runningLate: {
    appointmentsNow: Row[];
    appointmentsBeforeNow: Row[];
    notLoggedIn: Row[];
  };
}

const initialState: State = {
  loading: 'idle',
  orderBy: {
    availability: false,
    distance: false,
  },
  runningLate: {
    appointmentsBeforeNow: [],
    appointmentsNow: [],
    notLoggedIn: [],
  },
  error: undefined,
  rows: [],
};

const slice = buildSlice<State>(typePrefix, initialState, {
  extraReducers: (builder) => {
    addRtkQueryBridges<State, Row>(builder, [
      {
        endpoint: usersRunningLateApi.endpoints.getUsersRunningLate,
        mode: 'list',
        apply: (state, payload) => {
          const {
            not_logged_in: notLoggedIn = [],
            appointments_before_now: appointmentsBeforeNow = [],
            appointments_now: appointmentsNow = [],
          } = payload || {};
          state.runningLate = { notLoggedIn, appointmentsBeforeNow, appointmentsNow };
        },
        onPending: (state) => {
          state.loading = 'pending';
        },
        onRejected: (state) => {
          state.loading = 'declined';
        },
      },
    ]);
  },
});

export default slice.reducer;
